import React, { Component } from "react";
import { connect } from "react-redux";
import { getImageUrl, getPlaceHolderImage } from "../../../services";

const imageContainer = {
  height: "100%",
  width: "100%",
  objectFit: "cover",
  border: "1px solid #D3D3D3",
};

class ImageWrapper extends Component {
  render() {
    const { imgUrl, masterDetailsObj, className } = this.props || {};
    console.log(
      "Rendering ImageWrapper for imgUrl:",
      imgUrl,
      "and masterDetailsObj:",
      masterDetailsObj
    );

    const src = getImageUrl(imgUrl, masterDetailsObj);
    return (
      <img
        style={imageContainer}
        className={className}
        src={src}
        alt=""
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = getPlaceHolderImage();
        }}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  masterDetailsObj: state.masterDetails.masterDetailsObj, // Get masterDetailsObj from Redux store
});

export default connect(mapStateToProps, {})(ImageWrapper);
